import { InjectionToken } from '@angular/core';

export let UI_STATE = new InjectionToken('UI state for hiding and showing sections');
export let UI_STATE_VALUE = {};